<template>
  <div class="maintenance-container">
    <div class="maintenance-content">
      <div class="maintenance-icon">
        <el-icon :size="80"><Tools /></el-icon>
      </div>
      <h1 class="maintenance-title">系统维护中</h1>
      <p class="maintenance-message">
        {{ maintenanceInfo.message || "系统正在维护升级，请稍后再试" }}
      </p>
      <div
        v-if="maintenanceInfo.startTime || maintenanceInfo.endTime"
        class="maintenance-time"
      >
        <p v-if="maintenanceInfo.startTime">
          <span class="time-label">维护开始时间：</span>
          <span class="time-value">{{
            formatTime(maintenanceInfo.startTime)
          }}</span>
        </p>
        <p v-if="maintenanceInfo.endTime">
          <span class="time-label">预计结束时间：</span>
          <span class="time-value">{{
            formatTime(maintenanceInfo.endTime)
          }}</span>
        </p>
      </div>
      <div class="maintenance-actions">
        <el-button type="primary" @click="refreshPage">刷新页面</el-button>
        <el-button @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import { Tools } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
// import { getMaintenanceStatus } from "../api";
import { useStore } from "vuex";
import dayjs from "dayjs";

const router = useRouter();
const store = useStore();

// 从 store 中获取维护信息
const maintenanceInfo = computed(() => {
  return store.getters["maintenance/maintenanceInfo"];
});

let checkInterval: ReturnType<typeof setInterval> | null = null;
const intervalTime = 10000;
const mockTime = 1000;
onMounted(() => {
  // 每30秒检查一次维护状态
  checkInterval = setInterval(() => {
    fetchMaintenanceInfo().then(() => {
      if (!maintenanceInfo.value.isMaintenance) {
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = null;
        }
        // 维护结束，刷新页面
        setTimeout(() => {
          ElMessage({
            message: "系统维护结束，请重新登录",
            type: "success",
          });
          router.push("/login");
        }, mockTime);
      }
    });
  }, intervalTime);
});

// 组件卸载时清除定时器
onBeforeUnmount(() => {
  if (checkInterval) {
    clearInterval(checkInterval);
    checkInterval = null;
  }
});

// 格式化时间
const formatTime = (time: string) => {
  if (!time) return "";
  return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
};

// 刷新页面
const refreshPage = () => {
  window.location.reload();
};

// 返回上一页
const goBack = () => {
  if (window.history.length > 1) {
    router.go(-1);
  } else {
    router.push("/login");
  }
};

// 获取维护信息 mock
const getMaintenanceStatusMock = async (): Promise<{
  code: string;
  content: {
    isMaintenance?: boolean;
    message?: string;
    startTime?: string;
    endTime?: string;
  };
}> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        code: "success",
        content: {
          isMaintenance: false,
          message: "系统正在维护升级，请稍后再试",
          startTime: "2025-12-17 10:00:00",
          endTime: "2025-12-17 12:00:00",
        },
      });
    }, 1000);
  });
};

// 获取维护信息
const fetchMaintenanceInfo = async () => {
  try {
    const res = await getMaintenanceStatusMock();
    // const res = await getMaintenanceStatus();
    if (res?.code === "success" && res.content) {
      const info = res.content as {
        isMaintenance?: boolean;
        message?: string;
        startTime?: string;
        endTime?: string;
      };
      // 更新 store 中的维护信息
      store.dispatch("maintenance/setMaintenanceInfo", info);
    }
  } catch (error) {
    console.error("获取维护信息失败:", error);
  }
};
</script>

<style lang="scss" scoped>
.maintenance-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.maintenance-content {
  background: #fff;
  border-radius: 16px;
  padding: 60px 40px;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.maintenance-icon {
  color: #409eff;
  margin-bottom: 24px;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.maintenance-title {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 16px 0;
}

.maintenance-message {
  font-size: 16px;
  color: #606266;
  margin: 0 0 24px 0;
  line-height: 1.6;
}

.maintenance-time {
  background: #f5f7fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 32px;
  text-align: left;

  p {
    margin: 8px 0;
    font-size: 14px;
    color: #606266;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .time-label {
    color: #909399;
    margin-right: 8px;
  }

  .time-value {
    color: #303133;
    font-weight: 500;
  }
}

.maintenance-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}
</style>
